<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :setLoading="setLoading"
    :persistenceKey="'bank-transactions-list'"
    :rowClick="rowClickCallBack"
    ref="bank-transactions-list"
  />
  <!-- :persistenceKey="'bank-transactions-list'" -->
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import TransactionListTemplate from "../../templates/transaction-list.vue";
import {
  BankTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/finance/bank-tabs";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  props: {},
  async created() {
    await this.initialized();
  },
  data() {
    return {
      setLoading: false,
      FXCurrency: "FX",
    };
  },
  methods: {
    async initialized() {
      this.setLoading = true;
      this.setLoading = false;
    },
    rowClickCallBack() {
      // if (e.column.screenField != "GridRecordEllipsisMenu") {
      //   this.onRowClicked(e, {
      //     view: this,
      //     page: "bank-accounts-transaction",
      //     mode: "review",
      //     idProperty: "Code",
      //   });
      // }
    },
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Bank Accounts",
        ScreenName: "Bank Accounts - All",
        selectedIndex: GetIndexByTabName("Transactions"),
        tabs: BankTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CashBook",
              // filter: [["BankAccountCode", "=", parseInt(this.baseView.id)]],
              serverPaging: true,
              allowGrouping: false,
              // postProcessCallback: this.bankRecordPostProcess,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Bank Accounts",
                message: "Get Started, Add a Bank Account",
              },
            },
          },
          toolbar: {
            export: false,
            openFilter: true,
            search: false,
            columnChooser: true,
            expand: false,
          },
          columns: [
            {
              screenField: "Date",
              gridDataField: "Date",
              filterDataField: "Date",
              showInColumnChooser: true,
              filterIndex: 1,
              allowSorting: true,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "FXAmount",
              filterIndex: 0,
              type: "Integer",
              filterDataField: "FXAmountAbs",
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "Account",
              gridDataField: "BankAccountSearchText",
              dataField: "BankAccountSearchText",
              label: "Account",
              allowHiding: false,
              minWidth: ColumnWidth.TransactionAccount.minWidth,
              width: "auto",
              showInColumnChooser: true,
              cellTemplate: "RecordTwoLines",
              // cellTemplateRecord: undefined,
              exportFields: undefined,
              filterIndex: 6,
              filterDataField: "BankAccountSearchText",
              dataType: "string",
              type: "Text",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "BankAccountName",
                  },
                ],
                secondary: [
                  {
                    dataField: "BsbNoAndBankAccountNo",
                  },
                ],
              },
              // exportFields: [
              //   {
              //     dataField: "BankAccountName",
              //     label: "Account Name",
              //   },
              //   {
              //     dataField: "BsbNoAndBankAccountNo",
              //     label: "Bsb No And Account No",
              //   },
              // ],
            },
            {
              screenField: "TradingPartner",
              cellTemplate: undefined,
              cellTemplateRecord: undefined,
              exportFields: undefined,
              label: "Partner",
              allowSorting: true,
              showInColumnChooser: true,
              filterIndex: 3,
              filterDataField: "TradingPartner",
              type: "Text",
              minWidth: ColumnWidth.BankAccount.minWidth,
            },
            {
              screenField: "Customer",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 4
            },
            {
              screenField: "Supplier",
              filterDataField: "SupplierCode",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 4
            },

            {
              screenField: "TransactionType",
              dataField: "TransactionType",
              filterDataField: "TransactionType",
              filterIndex: 4,
              label: "Type ",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              minWidth: ColumnWidth.PaymentType.minWidth,
              maxWidth: ColumnWidth.PaymentType.minWidth,
              dataSourceConfig: {
                data: [
                  "Supplier Payment",
                  "Customer Receipt",
                  "Sundry Payment",
                  "Sundry Receipt",
                ],
              },
            },
            {
              screenField: "TransactionCode",
              width: 75,
              // type: "String",
              dataField: "ComputedTransaction",
              label: "Transaction",
              // minWidth: ColumnWidth.Code.minWidth,
              // maxWidth: ColumnWidth.Code.minWidth,
              showInColumnChooser: true,
              visible: true,
              allowSearch: true,
              allowSorting: true,
              hyperlink: {
                url: "",
                dataField: "ComputedTransaction",
                // dataField: "RefNo",
                gridUrlDataFields: ["TransactionType"],
                gridUrlConditions: [
                  {
                    values: [{ TransactionType: "Customer Receipt" }],
                    url: `customer-receipt/review/__ID__`,
                  },
                  {
                    values: [{ TransactionType: "Sundry Receipt" }],
                    url: `sundry-receipt/__ID__`,
                  },
                  {
                    values: [{ TransactionType: "Supplier Payment" }],
                    url: `supplier-payment/review/__ID__`,
                  },
                  {
                    values: [{ TransactionType: "Sundry Payment" }],
                    url: `sundry-payment/__ID__`,
                  },
                ],
                target: "_blank",
              },
              filterIndex: 0,
              filterDataField: "ComputedTransaction",
              dataType: "string",
              type: "Text",
            },
            {
              screenField: "Reference",
              label: "Reference",
              dataField: "Reference",
              visible: true,
              showInColumnChooser: true,
              minWidth: ColumnWidth.PaymentReference.minWidth,
              width: ColumnWidth.PaymentReference.minWidth,
            },
            {
              screenField: "Currency",
              cellTemplate: null,
              cellTemplateRecord: undefined,
              gridDataField: "CurrencyCode",
              exportFields: undefined,
              width: 70,
              minWidth: 70,
              filterIndex: 7,
            },
            {
              screenField: "ExchangeRate",
              label: `FX Rate`,
              visible: !this.isBankAccountCurrencyTheSameAsCompanyCurrency,
              minWidth: ColumnWidth.ExchangeRate.minWidth,
              maxWidth: ColumnWidth.ExchangeRate.minWidth,
              allowSearch: false,
            },
            {
              screenField: "FXBalance",
              dataField: "FXSpent",
              visible: !this.isBankAccountCurrencyTheSameAsCompanyCurrency,
              format: "Decimal-16-2",
              label: `Spent (${this.FXCurrency}) `,
              allowSorting: true,
              showInColumnChooser: true,
              allowSearch: false,
              minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              maxWidth: ColumnWidth.Price2DecimalPoints.width,
            },
            {
              screenField: "FXBalance",
              dataField: "Spent",
              format: "Decimal-16-2",
              label: `Spent (Base Currency)`,
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              allowSearch: false,
              minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              maxWidth: ColumnWidth.Price2DecimalPoints.width,
            },
            {
              screenField: "FXAmount",
              dataField: "FXReceived",
              label: `Received (${this.FXCurrency}) `,
              allowSorting: true,
              showInColumnChooser: true,
              minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              maxWidth: ColumnWidth.Price2DecimalPoints.width,
              visible: !this.isBankAccountCurrencyTheSameAsCompanyCurrency,
              allowSearch: false,
            },
            {
              screenField: "FXAmount",
              dataField: "Received",
              label: `Received (Base Currency)`,
              allowSorting: true,
              showInColumnChooser: true,
              minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              maxWidth: ColumnWidth.Price2DecimalPoints.width,
              visible: true,
              allowSearch: false,
            },
            {
              screenField: "DateCreated",
              dataField: "DateCreated",
              filterDataField: "DateCreated",
              filterIndex: 2,
              label: "Date Created",
              allowSorting: true,
              showInColumnChooser: true,
              visible: false,
              sortOrder: "desc",
              maxWidth: ColumnWidth.DateCreated.width,
            },
            {
              screenField: "CreatedBy",
              dataField: "CreatedBy",
              label: "Created By",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              maxWidth: ColumnWidth.Name.width,
            },
            {
              screenField: "OrderStatus",
              dataField: "FriendlyStatus",
              label: "Status",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              filterIndex: 5,
              filterDataField: "FriendlyStatus",
              dataSourceConfig: {
                data: ["Reconciled", "Unpresented"],
              },
            },
          ],
        },
      };
      return config;
    },
  },
};
</script>
<style lang="scss"></style>
